export const isclosedoutproductLabelText = $localize`:ConfigStrip|Close out label@@closeOutLabelText:Close-out`;
export const keyarticlesLabelText = $localize`:ConfigStrip|Key articles label@@keyArticlesLabelText:Key Article`;
